import { parse, serialize } from "cookie";

const handleNavigation = (e, linkCallbackFunction, label) => {
  if (linkCallbackFunction) {
    const { pathname, hash, search } = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    linkCallbackFunction(`${pathname}${hash}${search}`);
  }
  window?.utag?.link({
    ga_event_category: "side navbar",
    ga_event_action: "click",
    ga_event_label: label,
    page_title: `${window.document.title}`,
    page_url: `${window.location.pathname}`,
    event: "trackEvent",
  });
};

/**
 * Sets the qpp_side_nav_expanded cookie value
 * @param {Document} document object
 * @param {string} value
 * @returns {void}
 */
const setSideNavExpanded = (_document, value) => {
  const secure = _document.location.protocol === "https:";
  _document.cookie = serialize("qpp_side_nav_expanded", value, {
    path: "/",
    secure,
  });
};

/**
 * Check if sidenav is expanded
 * @param {Document} document object
 * @returns {boolean}
 */
const isSideNavExpanded = (_document) => {
  const parsedCookies = parse(_document.cookie);
  if (parsedCookies.qpp_side_nav_expanded === undefined) {
    setSideNavExpanded(_document, "true");
    return true;
  }
  return parsedCookies.qpp_side_nav_expanded === "true";
};

export { handleNavigation, setSideNavExpanded, isSideNavExpanded };
